import { TableUi } from "./Power";

const Revenue = () => (
  <TableUi
    title="Revenue"
    header={false}
    list={[
      "Property Tax Assessment & Collection",
      "Enlistment Certificate for Profession, Trade & Calling",
      "Fees for Advertisements & Car Parking",
      "Fees for Amusement",
      "Other statutory fees and charges",
    ]}
  />
);



export default Revenue;
